import { decryptAesGcm, stripKeyPrefix } from '@/infra/crypto/core'
import { getKeyByVersion } from '@/infra/crypto/key-ring'
import type { KeyRing } from '@/infra/crypto/key-ring'
import type { EncryptedPayload } from './types'

export const decryptField = async (
  payload: EncryptedPayload,
  keyRing: KeyRing,
): Promise<unknown> => {
  const encryptionKey = getKeyByVersion(keyRing, payload.keyVersion)
  if (!encryptionKey) {
    throw new Error(
      'Decryption failed: required key not available in key ring. Verify your key ring file contains all necessary key versions.',
    )
  }

  const rawKey = stripKeyPrefix(encryptionKey.key)
  const decryptedBytes = await decryptAesGcm(payload.ciphertext, payload.iv, rawKey)

  const decoder = new TextDecoder()
  const text = decoder.decode(decryptedBytes)

  try {
    return JSON.parse(text) as unknown
  } catch {
    // Daemon encrypts strings as raw UTF-8 bytes (not JSON-encoded).
    // JSON.parse fails for these — return the raw string.
    return text
  }
}
